<template>
  <QualificationList :userId="userData.id">
    <template v-slot:header>
      <SectionThreeItemsHeader class="mb-6 mt-2">
        <template v-slot:item-center>
          <h2>Qualifications</h2>
        </template>
        <template v-slot:item-right>
          <EditQualificationsAction v-if="isEditable" />
        </template>
      </SectionThreeItemsHeader>
    </template>
  </QualificationList>
</template>

<script>
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import EditQualificationsAction from "@/views/settings/components/actions/EditQualificationsAction";
import QualificationList from "@/components/workers/qualifications/QualificationList";

export default {
  components: {
    EditQualificationsAction,
    SectionThreeItemsHeader,
    QualificationList
  },
  props: {
    userData: {
      type: Object,
      required: true
    },
    isEditable: Boolean
  }
};
</script>

<style lang="scss"></style>
